import React from 'react';

// Corner cobweb anchored at (0,0); mirrored via CSS for other corners.
const RADIALS = [0, 15, 32, 50, 68, 90].map((d) => (d * Math.PI) / 180);
const RINGS = [22, 44, 68, 94];
const pt = (r, a) => [r * Math.cos(a), r * Math.sin(a)];
const WEB_PATH = (() => {
  let d = RADIALS.map((a) => { const [x, y] = pt(118, a); return `M0 0L${x.toFixed(1)} ${y.toFixed(1)}`; }).join('');
  RINGS.forEach((r) => {
    for (let i = 0; i < RADIALS.length - 1; i += 1) {
      const [x1, y1] = pt(r, RADIALS[i]);
      const [x2, y2] = pt(r, RADIALS[i + 1]);
      const [cx, cy] = pt(r * 0.86, (RADIALS[i] + RADIALS[i + 1]) / 2);
      d += `M${x1.toFixed(1)} ${y1.toFixed(1)}Q${cx.toFixed(1)} ${cy.toFixed(1)} ${x2.toFixed(1)} ${y2.toFixed(1)}`;
    }
  });
  return d;
})();

export const Cobweb = ({ className }) => (
  <svg viewBox="0 0 120 120" className={className} aria-hidden="true">
    <path d={WEB_PATH} className="sd-web-halo" fill="none" strokeWidth="2.2" strokeLinecap="round" />
    <path d={WEB_PATH} className="sd-web-line" fill="none" strokeWidth="0.9" strokeLinecap="round" />
  </svg>
);

export const Spider = ({ className }) => (
  <svg viewBox="0 0 40 40" className={className} aria-hidden="true">
    <g stroke="#1B1622" strokeWidth="1.6" fill="none" strokeLinecap="round">
      <path d="M16 20 Q9 14 5 17M16 22 Q8 21 4 25M17 24 Q10 28 7 33M18 18 Q13 10 9 9" />
      <path d="M24 20 Q31 14 35 17M24 22 Q32 21 36 25M23 24 Q30 28 33 33M22 18 Q27 10 31 9" />
    </g>
    <ellipse cx="20" cy="23" rx="5.5" ry="6.5" fill="#1B1622" />
    <circle cx="20" cy="15.5" r="3.6" fill="#241D2D" />
    <circle cx="18.6" cy="15" r="0.8" fill="#F2A541" /><circle cx="21.4" cy="15" r="0.8" fill="#F2A541" />
  </svg>
);

export const Pumpkin = ({ className, face = false }) => (
  <svg viewBox="0 0 64 56" className={className} aria-hidden="true">
    <path d="M32 12 C31 7 33 4 37 2" stroke="#4F6B2E" strokeWidth="3" fill="none" strokeLinecap="round" />
    <ellipse cx="20" cy="34" rx="14" ry="18" fill="#D9651E" />
    <ellipse cx="44" cy="34" rx="14" ry="18" fill="#D9651E" />
    <ellipse cx="32" cy="34" rx="13" ry="19.5" fill="#EE7F2D" />
    <path d="M32 15 V53M24 16 Q20 34 24 52M40 16 Q44 34 40 52" stroke="#B8521A" strokeWidth="1.2" fill="none" opacity="0.6" />
    {face && (
      <g fill="#3A1C0A">
        <path d="M22 30 l5 -5 l5 5z" /><path d="M36 30 l5 -5 l5 5z" />
        <path d="M21 39 Q32 48 43 39 L39 41 L36 39 L32 42 L28 39 L25 41z" />
      </g>
    )}
  </svg>
);

export const Bat = ({ className }) => (
  <svg viewBox="0 0 64 28" className={className} aria-hidden="true">
    <path fill="#231B2B" d="M32 9c1.6 0 2.6-2.8 3.4-4.6.6 1.6 1 3.4.8 5 4.5-4.4 12-6.9 19.6-6.4-2.6 2.3-3.8 5.6-3.6 9-3.1-1.6-6.5-1.4-8.6 1.1-2.4-1.5-5.6-.9-7.2 1.9-1.6 1.1-3.2 3.6-4.4 6.8-1.2-3.2-2.8-5.7-4.4-6.8-1.6-2.8-4.8-3.4-7.2-1.9-2.1-2.5-5.5-2.7-8.6-1.1.2-3.4-1-6.7-3.6-9 7.6-.5 15.1 2 19.6 6.4-.2-1.6.2-3.4.8-5C29.4 6.2 30.4 9 32 9z" />
  </svg>
);
